import * as React from "react";
const USFlagSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path fill="#BD3D44" d="M0 4h32v24H0" />
    <path
      fill="#000"
      d="M0 6.765h32H0Zm0 3.685h32H0Zm0 3.7h32H0Zm0 3.7h32H0Zm0 3.7h32H0Zm0 3.7h32H0Z"
    />
    <path
      stroke="#fff"
      strokeWidth={1.85}
      d="M0 6.765h32M0 10.45h32m-32 3.7h32m-32 3.7h32m-32 3.7h32m-32 3.7h32"
    />
    <path fill="#192F5D" d="M0 4h18.24v12.925H0" />
  </svg>
);
export default USFlagSVG;
